import React, { createContext, useContext, useEffect, useReducer } from "react";
import { get, post } from "../services/base";

const AuthContext = createContext();

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
};

const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
      };
    case "LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
      };
    default:
      return state;
  }
};

const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const login = async (username, password, pin) => {
    try {
      const response = await post("/Usuario", {
        username: username,
        password: password,
        pin: pin,
      });

      if (response && response.data && response.data.ok === true) {
        const userResponse = await getUserInfo();
        if (userResponse.ok) {
          const { ok, token, mensaje } = response.data;
          dispatch({
            type: "LOGIN_SUCCESS",
            payload: { mensaje, token, user: userResponse.user, ok },
          });

          localStorage.setItem("IsIn", true);
          localStorage.setItem("name", userResponse.user.nombreUsuario);
          localStorage.setItem("username", userResponse.user.usuarioId);
          localStorage.setItem("userType", userResponse.user.codigoTipoUsuario);
          localStorage.setItem("userId", userResponse.user.id);
          //TODO: Change this to the real value
          if (userResponse.user.isTermAccepted !== null) {
            localStorage.setItem(
              "isTermAccepted",
              userResponse.user.isTermAccepted.toLowerCase(),
            );
          } else {
            localStorage.setItem("isTermAccepted", null);
          }
          return { ok: true, mensaje: mensaje, token: token };
        } else {
          return { ok: false, mensaje: "Error fetching user information" };
        }
      } else {
        const { ok, mensaje } = response.data;
        return { ok: ok, mensaje: mensaje };
      }
    } catch (error) {
      console.error("Error logging in:", error);
      return { ok: false };
    }
  };

  const logout = () => {
    dispatch({ type: "LOGOUT" });
  };

  return (
    <AuthContext.Provider value={{ state, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

const getUserInfo = async () => {
  try {
    const userResponse = await get("/Usuario");

    if (userResponse && userResponse.data) {
      return { ok: true, user: userResponse.data };
    } else {
      return { ok: false };
    }
  } catch (error) {
    console.error("Error fetching user information:", error);
    return { ok: false };
  }
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export { AuthProvider, useAuth };
